// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.album-card {
  margin: 16px;
  border-radius: 10px;
  overflow: hidden;
}
.album-card .cover-image {
  position: relative;
}
.album-card .cover-image img {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 10px 10px;
}
.album-card .card-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.album-card .card-content .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  font-size: 18px;
  font-weight: bold;
}
.album-card .card-content .rating {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 5px;
}
.album-card .card-content .rating ion-icon {
  margin-right: 8px;
}
.album-card .card-content .price {
  font-size: 16px;
  font-weight: bold;
}

.user-details-col {
  position: absolute;
  bottom: 4px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.2));
}
.user-details-col.blocked {
  padding-bottom: 28px;
}
.user-details-col .user-level-name {
  margin: 0px;
  margin-bottom: calc(var(--page-margin) / 2);
  min-width: 40%;
  font-size: 16px;
}
.user-details-col .user-level-country {
  margin: 0px;
  margin-bottom: calc(var(--page-margin) / 2);
  min-width: 40%;
  text-transform: uppercase;
  padding-top: 4px;
}
.user-details-col .user-metric {
  font-size: 56px;
}
.user-details-col .user-label {
  font-size: 14px;
  font-weight: 300;
  min-width: 60%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/album-card/album-card.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;AACZ;AAGI;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AADR;AAGQ;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AADZ;AAIQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAFZ;AAIY;EACI,iBAAA;AAFhB;AAQQ;EACI,eAAA;EACA,iBAAA;AANZ;;AAaA;EACI,kBAAA;EACA,WAAA;EACA,oBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EAEA,uEAAA;AAZJ;AAcI;EACI,oBAAA;AAZR;AAgBI;EACI,WAAA;EACA,2CAAA;EACA,cAAA;EAEA,eAAA;AAfR;AAkBI;EACI,WAAA;EACA,2CAAA;EACA,cAAA;EAEA,yBAAA;EACA,gBAAA;AAjBR;AAoBI;EACI,eAAA;AAlBR;AAqBI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAnBR","sourcesContent":[".album-card {\r\n    margin: 16px;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n\r\n    .cover-image {\r\n        position: relative;\r\n\r\n        img {\r\n            width: 100%;\r\n            max-height: 200px;\r\n            object-fit: cover;\r\n            border-radius: 10px 10px;\r\n        }\r\n    }\r\n\r\n    .card-content {\r\n        padding: 10px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n\r\n        .title {\r\n            width: 100%;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            flex-direction: row;\r\n            font-size: 18px;\r\n            font-weight: bold;\r\n        }\r\n\r\n        .rating {\r\n            display: flex;\r\n            align-items: center;\r\n            font-size: 14px;\r\n            margin-bottom: 5px;\r\n\r\n            ion-icon {\r\n                margin-right: 8px;\r\n            }\r\n\r\n            .duration {}\r\n        }\r\n\r\n        .price {\r\n            font-size: 16px;\r\n            font-weight: bold;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.user-details-col {\r\n    position: absolute;\r\n    bottom: 4px;\r\n    padding-bottom: 40px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: white;\r\n\r\n    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.2));\r\n\r\n    &.blocked {\r\n        padding-bottom: 28px;\r\n    }\r\n\r\n\r\n    .user-level-name {\r\n        margin: 0px;\r\n        margin-bottom: calc(var(--page-margin) / 2);\r\n        min-width: 40%;\r\n\r\n        font-size: 16px;\r\n    }\r\n\r\n    .user-level-country {\r\n        margin: 0px;\r\n        margin-bottom: calc(var(--page-margin) / 2);\r\n        min-width: 40%;\r\n\r\n        text-transform: uppercase;\r\n        padding-top: 4px;\r\n    }\r\n\r\n    .user-metric {\r\n        font-size: 56px;\r\n    }\r\n\r\n    .user-label {\r\n        font-size: 14px;\r\n        font-weight: 300;\r\n        min-width: 60%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
